export enum BundleProductsCode {
    wolandCore = 'WolandCore',
    wolandAdvanced = 'WolandAdvanced',
}
